import React from "react";
import {Route} from "react-router-dom";
import loadable from "../loadable";
import PubSub from "pubsub-js";
import Utils from "../public/utils";
import noPermissions from "../config/noPermissions/noPermissions";
import {connect} from "react-redux";

const Recharge = loadable(() => import('./recharge/recharge'));
const Settle = loadable(() => import('./settle/settle'));
const Summary = loadable(() => import('./summary/summary'));
const CashIndex = loadable(() => import('./withdraws/cash'));
const Withdraws = loadable(() => import('./withdraws/withdraws'));
const Statements = loadable(() => import('./statement/statements'));
const AssetsOverview = loadable(() => import('./overview/assets_overview'));

/**
 * 资产管理；
 */
class AssetsRouter extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <>
                {
                    this.props.subInfo.isSub == 0 ?
                        <>
                            {/**资产概览**/}
                            <Route exact path={this.props.match.url + "/overview"} component={AssetsOverview}/>
                            {/*结算记录*/}
                            <Route exact path={this.props.match.url + '/settle/:type'} component={Settle}/>
                            {/**对账单**/}
                            <Route exact path={this.props.match.url + "/statements"} component={Statements}/>
                            {/**提现记录**/}
                            <Route exact path={this.props.match.url + "/withdraws"} component={Withdraws}/>
                            {/**提现**/}
                            <Route exact path={this.props.match.url + "/withdraws/cash"} component={CashIndex}/>
                            {/**对账单**/}
                            <Route exact path={this.props.match.url + "/summary"} component={Summary}/>
                            <Route exact path={this.props.match.url + "/recharge"} component={Recharge}/>
                        </> : this.props.subInfo.isSub == 1 ?
                        <>
                            {/**资产概览**/}
                            <Route exact path={this.props.match.url + "/overview"}
                                   component={Utils.wxWorkHelperJurisdiction(this.props.subInfo.permissionConf,'marketAssert','marketAssert_overview') ?
                                       AssetsOverview : noPermissions}/>
                            {/*结算记录*/}
                            <Route exact path={this.props.match.url + '/settle/:type'}
                                   component={Utils.wxWorkHelperJurisdiction(this.props.subInfo.permissionConf,'marketAssert','marketAssert_settle') ?
                                       Settle : noPermissions}/>
                            {/**对账单**/}
                            <Route exact path={this.props.match.url + "/statements"}
                                   component={Utils.wxWorkHelperJurisdiction(this.props.subInfo.permissionConf,'marketAssert','marketAssert_statements') ?
                                       Statements : noPermissions}/>
                            {/**提现记录**/}
                            <Route exact path={this.props.match.url + "/withdraws"}
                                   component={Utils.wxWorkHelperJurisdiction(this.props.subInfo.permissionConf,'marketAssert','marketAssert_withdraws') ?
                                       Withdraws : noPermissions}/>
                            {/**提现**/}
                            <Route exact path={this.props.match.url + "/withdraws/cash"} component={this.props.subInfo.isSub == 1 ? noPermissions : CashIndex}/>
                            {/**对账单**/}
                            <Route exact path={this.props.match.url + "/summary"}
                                   component={Utils.wxWorkHelperJurisdiction(this.props.subInfo.permissionConf,'marketAssert','marketAssert_summary') ?
                                       Summary : noPermissions}/>
                            <Route exact path={this.props.match.url + "/recharge"} component={Recharge}/>
                        </> : <></>
                }
            </>
        )
    }
}
export default connect(state=>{
    const {subReducer} = state
    return {
        subInfo : subReducer
    }
},null)(AssetsRouter)